import { render } from "./WarehouseEdit.vue?vue&type=template&id=2e6033ff&scoped=true&ts=true"
import script from "./WarehouseEdit.vue?vue&type=script&lang=ts"
export * from "./WarehouseEdit.vue?vue&type=script&lang=ts"

import "./WarehouseEdit.vue?vue&type=style&index=0&id=2e6033ff&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6033ff"]])

export default __exports__